import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';

type AdditionalInfoProps = {
    title: string;
    url: string;
};

function AdditionalInfo({ title, url }: AdditionalInfoProps): JSX.Element {
    return (
        <section className="py-4 flex gap-x-1 text-xs font-normal border-t border-gray-200 dark:border-white/[0.07]">
            <p className="text-gray-600 dark:text-gray-400">Learn more about</p>
            <a className="flex gap-x-1 text-indigo-600 dark:text-indigo-400" href={url} target="_blank" rel="noreferrer">
                {title}
                <ArrowTopRightOnSquareIcon className="w-4 h-4" />
            </a>
        </section>
    );
}

export default AdditionalInfo;
